<template>
    <div>
        <c-search-box ref="searchbox" @enter="getList">
            <template slot="search">
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
                    <c-text
                        label="자재명"
                        name="materialName"
                        placeholder="자재명"
                        v-model="searchParam.materialName"
                        @datachange="getList"
                    >
                    </c-text>
                </div>
            </template>
        </c-search-box>
        <c-table
            ref="materialTable"
            title="자재 목록"
            :columns="grid.columns"
            :data="grid.data"
            :gridHeight="grid.height"
            :selection="popupParam.type"
            rowKey="materialCd"
        >
            <!-- 버튼 영역 -->
            <template slot="table-button">
                <q-btn-group outline>
                    <c-btn label="선택" icon="check" @btnClicked="select" />
                    <!-- <c-btn label="검색" icon="search" @btnClicked="getList" /> -->
                </q-btn-group>
            </template>
        </c-table>
    </div>
</template>

<script>
import selectConfig from "@/js/selectConfig";
export default {
    name: "material-pop",
    props: {
        popupParam: {
            type: Object,
            default: () => ({
                type: "single",
                plantCd: "",
            }),
        },
        contentHeight: {
            type: [String, Number],
            default: function () {
                return "auto";
            },
        },
    },
    data() {
        return {
            listUrl: "",
            grid: {
                columns: [
                    {
                        name: "materialCd",
                        field: "materialCd",
                        label: "자재코드",
                        align: "center",
                        style: "width:150px",
                        sortable: true,
                    },
                    {
                        name: "materialName",
                        field: "materialName",
                        label: "자재명",
                        align: "left",
                        sortable: true,
                    },
                ],
                data: [],
                height: "100%",
            },
            searchParam: {
                materialName: "",
                useFlag: "Y",
                chemFlag: "N",
            },
            editable: true,
            searchUrl: "",
        };
    },
    beforeCreate() {},
    created() {},
    beforeMount() {
        Object.assign(this.$data, this.$options.data());
    },
    mounted() {
        this.init();
    },
    beforeDestroy() {},
    watch: {
        contentHeight() {
            let height =
                this.contentHeight -
                this.$refs["searchbox"].$el.offsetHeight -
                50;
            if (height < 400) {
                height = 500;
            }
            this.grid.height = height + "px";
        },
    },
    methods: {
        init() {
            this.listUrl = selectConfig.mdm.mam.material.list.url;
            this.searchParam.plantCd = this.popupParam.plantCd;
            this.getList();
        },
        getList() {
            this.$http.url = this.listUrl;
            this.$http.type = "GET";
            this.$http.param = this.searchParam;
            this.$http.request((_result) => {
                this.grid.data = _result.data;
            });
        },
        select() {
            let selectData = this.$refs["materialTable"].selected;
            if (!selectData || selectData.length === 0) {
                window.getApp.$emit("ALERT", {
                    title: "안내", // 안내
                    message: "자재를 선택하세요.", // 자재를 선택하세요.
                    type: "warning", // success / info / warning / error
                });
            } else {
                this.$emit("closePopup", selectData);
            }
        },
    },
};
</script>
